class AutoTabs {
  constructor(el) {
    if (!el) return;
    // Start Tabs
    var tabTimeout;
    clearTimeout(tabTimeout);
    tabLoop();

    // Connect your class names to elements.
    function tabLoop() {
      tabTimeout = setTimeout(function () {
        var $next = $(".c-tabs-menu").children(".w--current:first").next();

        if ($next.length) {
          $next.click(); // user click resets timeout
        } else {
          $(".c-tabs-link:first").click();
        }
      }, 3000); // 5 Second Rotation
    }

    // Reset Loops
    $(".c-tabs-link").click(function () {
      clearTimeout(tabTimeout);

      tabLoop();
    });
  }
}

export default AutoTabs;
